import React, { Component } from 'react';
import './HomeOwnerDashboard.scss';
import Button from '../Button';
import FontAwesomeIcon from '../Icon';
import moment from 'moment';
const walkthrough = [
    {
        label: 'Your property walkthrough is now active. Click below to get started.',
        button: 'Begin Walk Through',
        status: 'Begin'
    },
    {
        label: 'Your property walk through is in progress. Click below to resume',
        button: 'Continue Walk Through',
        status: 'In Progress'
    },
    {
        label: 'Your property walk through is complete. Click below to view the final details',
        button: 'View Walk Through',
        status: 'Review'
    },
    {
        label: 'Your property walkthrough is now active. Click below to schedule.',
        button: 'Schedule',
        status: 'Schedule'
    },
    {
        label: 'Your property walkthrough is now scheduled. Click below to Reschedule.',
        button: 'Reschedule',
        status: 'Reschedule'
    }
]

class Walkthrough extends Component {

    setChecklistBar = (data) => {
        let width = (190 / 100);
        // //226/220
        let cwidth = 0;
        let totalchecklist = 0;
        let totalcheckedlist = 0;

        let areasCheckList = []
        // if(data.sideBarCheckList && data.sideBarCheckList.areasCheckList.length > 0){
        totalcheckedlist = data.totalCheckedChecklist;
        totalchecklist = data.totalChecklist
        // areasCheckList = data.sideBarCheckList.areasCheckList
        if (data.totalCheckedChecklist !== 0) {
            if (totalcheckedlist === totalchecklist) {
                cwidth = width * 103;
            } else {
                let totalCount = data.totalCheckedChecklist / data.totalChecklist * 100
                width = width * totalCount
                cwidth = width
            }
        }
        // }
    }
    setWalkthroughStatus = (data) => {
        if (data.walkthroughType === "Simplified") {
            if (data.status === "Activate") {
                return 'Yet To Be Activated';
            } else if(data.status === 'Schedule') {
                return "Schedule";
            } else if (data.status === 'Begin' && data?.schedule) {
                return "Reschedule";
            } else if (data.status === 'Begin' || data.status === 'Guided Walk Through' || data.status === 'Self-Guided Walk Through') {
                return "Begin";
            } else if (data.status === 'In Progress Home Only') {
                return "In Progress";
            } else {
                return data.status;
            }
        } else {
            if (data.status === null || data.status === 'In Progress' || data.status === 'Activate' || data.status === 'Configure') {
                return 'Yet To Be Activated';
              }
              if (data.status === 'Schedule') {
                return "Schedule";
              }
              if (data.status === 'Begin' && data?.schedule) {
                return "Reschedule"
              }
              if (data.status === 'Begin' || data.status === 'Review') {
                return data.status;
              }
              if (data.status === 'Guided Walk Through' || data.status === 'Self-Guided Walk Through') {
                return "Begin";
              }
            //   if (data.status === 'Self-Guided Walk Through') {
            //     return <div><Button label="begin" icon={(<Icon glyph="walking" weight="light" size="small" />
            //     )} color="teal" size="small" /></div>
            //   }
              if (data.status === 'In Progress Home' || data.status === 'In Progress Home Only') {
                return "In Progress";
              }
              if (data.status === 'Reviewed By Home Owner') {
                return "Review"
              }
        }
    }
    convertToLocalTime(datestring) {
        let date = moment(datestring).local().format('MMM Do ddd hh:mm A');
        return date;
      }
    render() {
        const { walkthroughData, handleStatus } = this.props;
        return (
            <div className='homeDasboard__mainTile'>
                <div style={{ padding: 20 }}>
                    <label className='homeDasboard__title'>PROPERTY WALK THROUGH</label>
                    <div className='homeDasboard__list'>
                        {walkthroughData && walkthroughData.length > 0 ? walkthroughData.map((data) => {
                            // const {cwidth, totalcheckedlist, totalchecklist} = this.setChecklistBar(data);
                            let object;

                            let width = (190 / 100);
                            // //226/220
                            let cwidth = 0;
                            let totalchecklist = 0;
                            let totalcheckedlist = 0;
                    
                            let areasCheckList = []
                            // if(data.sideBarCheckList && data.sideBarCheckList.areasCheckList.length > 0){
                            totalcheckedlist = data.totalCheckedChecklist;
                            totalchecklist = data.totalChecklist
                            // areasCheckList = data.sideBarCheckList.areasCheckList
                            if (data.totalCheckedChecklist !== 0) {
                                if (totalcheckedlist === totalchecklist) {
                                    cwidth = width * 103;
                                } else {
                                    let totalCount = data.totalCheckedChecklist / data.totalChecklist * 100
                                    width = width * totalCount
                                    cwidth = width
                                }
                            }
                            // }

                           const status =  this.setWalkthroughStatus(data);
                            object = walkthrough.find(o => o.status === status)
                            return (
                                <div className='walkthroughBoxshadow'>
                                    <div className='homeDasboard__tableItem' style={{fontSize: '1.6rem'}}>{data.walkthroughName}</div>
                                     <div className='homeDasboard__tile'>
                                        {status === 'Review' &&
                                            <div style={{ color: '#00044C', paddingRight: 10 }}>
                                                <FontAwesomeIcon
                                                    glyph="check"
                                                    weight="solid"
                                                    size="medium"
                                                />
                                            </div>}
                                           
                                        {status === 'In Progress' && data.walkthroughType !== "Simplified" &&
                                        <div className="homeDasboard__anchor">
                                            <div className='walkThroughSideBar__progressBar' style={{ backgroundColor: '#DFE3E8' }}>
                                                <div style={{ backgroundColor: '#00044C', width: cwidth, height: 15, borderRadius: 2 }} />
                                            </div>
                                            <div style={{ paddingLeft: 10 }}>
                                                {totalcheckedlist + "/" + totalchecklist}
                                            </div>
                                        </div>}
                                    </div>
                                    <label className='homeDasboard__walkthrouthText'>{object?.label}</label>
                                    <div style={{ paddingTop: 5, display: 'flex', justifyContent: 'center' }}>
                                        <Button
                                            color="teal"
                                            size="small"
                                            label={object?.button}
                                            icon={
                                                <FontAwesomeIcon
                                                    glyph="key"
                                                    weight="light"
                                                    size="small"
                                                />
                                            }
                                            onClick={() => handleStatus(data)}
                                        />
                                    </div> 
                                </div>
                            )
                        }) : null}
                    </div>
                </div>
            </div>
        )
    }
}
export default Walkthrough;